import React, { useState } from 'react';
import PropTypes from 'prop-types';

const CkbPages = function ckbPages({
  child, handleHTML, setGetId,
}) {
  ckbPages.propTypes = {
    child: PropTypes.shape({
      title: PropTypes.string.isRequired,
      child: PropTypes.shape.isRequired,
      id: PropTypes.number.isRequired,
    }).isRequired,
    handleHTML: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    setGetId: PropTypes.func.isRequired,
  };
  const [expand, setExpand] = useState(false);
  const handleIndex = (data) => {
    if (child) {
      handleHTML(data);
    }
  };

  const handleId = (index) => {
    setGetId(index);
  };

  if (child?.child) {
    return (
      <div>

        <div className="">
          <button
            type="button"
            className="text-start"
            style={{
              background: 'none', border: 'none', appearence: 'none', color: '#0080FA',
            }}
            onClick={() => {
              setExpand(!expand); handleIndex(child); handleId(child.id);
            }}
          >
            {child?.title}
            <br />
          </button>
          <div style={{ display: expand ? 'block' : 'none', paddingLeft: '20px' }}>
            {child.child?.map((data, index) => (
              <span key={data}>
                <CkbPages
                  id={index}
                  setGetId={setGetId}
                  child={data}
                  handleHTML={handleHTML}
                />
              </span>
            ))}
          </div>
        </div>
      </div>
    );
  }
  return (
    <button
      className="mb-0 text-start"
      type="button"
      onClick={() => {
        handleIndex(child); handleId(child.id);
      }}
      style={{
        background: 'none', border: 'none', appearence: 'none', color: '#0080FA',
      }}
    >
      {child?.title}
    </button>
  );
};

export default CkbPages;
